module.exports = " <header _v-c54d43ec=\"\"> <img src=" + require("../assets/css/cnodejs_light.svg") + " alt=\"\" _v-c54d43ec=\"\"> </header> ";


/*****************
 ** WEBPACK FOOTER
 ** ./~/.npminstall/vue-html-loader/1.2.3/vue-html-loader!./~/.npminstall/vue-loader/8.5.3/vue-loader/lib/template-rewriter.js?id=_v-c54d43ec!./~/.npminstall/vue-loader/8.5.3/vue-loader/lib/selector.js?type=template&index=0!./src/components/header.vue
 ** module id = 175
 ** module chunks = 9
 **/